import { Link, useLocation, useNavigate } from "react-router-dom";
import { showValueBasedOnColumn } from "../../../utils/table/tableRowsColumns";
import styles from "./table.module.css"
import { ClimateDataType } from "../../../types/climateData/ClimateDataTypes";
import Loader from "../../loader/Loader";
import translations from "../../translations";
import { useLanguage } from "../../contexts/LanguageContext";

interface ForecastTableProps {
    loading: boolean
    rows: ClimateDataType[];
    headers: { label: string; visible: boolean }[];
}

const ForecastTable = (props: ForecastTableProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { headers, rows, loading } = props
    const { selectedLanguage } = useLanguage();


    const renderBody = ({ loading, rows, headers }: ForecastTableProps) => {
        if (loading) {
            return (
                <tr>
                    <td className={styles.loaderCell} colSpan={headers?.filter((item) => item?.visible)?.length}>
                        <Loader />
                    </td>
                </tr>
            );
        }

        if (!loading && !rows?.length) {
            return (
                <tr>
                    <td className={styles.emptyCell} colSpan={headers?.filter((item) => item?.visible)?.length}>
                        {translations[selectedLanguage].noData}
                    </td>
                </tr>
            );
        }

        return rows.map((row, rowIndex) => (
            <Link
                key={rowIndex}
                className={styles.rowStyles}
                to={`/forecast${location?.search}`}
            // onClick={() => { navigate(`/forecast${location?.search}`); }}
            >
                {headers?.filter((item) => item?.visible)?.map((header, index) => (
                    <td key={index} className={styles.cellStyles}>
                        {showValueBasedOnColumn({ column: header, row })}
                    </td>
                ))}
            </Link>
        ));
    };


    return (
        <table className={styles.tableStyles}>
            <thead>
                <tr>
                    {headers?.filter((item) => item?.visible)?.map((header, index) => (
                        <th key={index} className={styles.headerStyles}>{header.label}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {renderBody({ loading, rows, headers })}
            </tbody>
        </table>
    );
};

export { ForecastTable };